// Game-module shim (unify Phase 3): resolves to the active game's FirebaseService.
// Conditional require is load-bearing here: each implementation calls
// initializeApp() with its own game's Firebase project at import time.
import game from '../games';
const impl = game.id === 'mlbb'
  ? require('../games/mlbb/services/FirebaseService')
  : require('../games/dota/services/FirebaseService');
export const DEMO_MODE = impl.DEMO_MODE;
export const demoStorage = impl.demoStorage;
export const auth = impl.auth;
export const db = impl.db;
export const googleProvider = impl.googleProvider;
export default impl.default;
